export default function InfoIcon({ className }: { className?: string }) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99986 2.18262C7.65144 2.18262 6.3333 2.58247 5.21213 3.33161C4.09096 4.08075 3.21712 5.14554 2.7011 6.39131C2.18508 7.63709 2.05007 9.00791 2.31313 10.3304C2.5762 11.6529 3.22552 12.8677 4.179 13.8212C5.13247 14.7747 6.34728 15.424 7.66979 15.6871C8.9923 15.9501 10.3631 15.8151 11.6089 15.2991C12.8547 14.7831 13.9194 13.9092 14.6686 12.7881C15.4177 11.6669 15.8176 10.3488 15.8176 9.00034C15.8176 7.19217 15.0993 5.45805 13.8207 4.17948C12.5421 2.90091 10.808 2.18262 8.99986 2.18262ZM8.99986 14.1136C7.98854 14.1136 6.99994 13.8137 6.15906 13.2519C5.31819 12.69 4.6628 11.8914 4.27579 10.9571C3.88878 10.0228 3.78752 8.99467 3.98481 8.00279C4.18211 7.01091 4.66911 6.09981 5.38421 5.3847C6.09932 4.66959 7.01042 4.1826 8.0023 3.9853C8.99419 3.788 10.0223 3.88926 10.9566 4.27627C11.891 4.66329 12.6896 5.31867 13.2514 6.15955C13.8133 7.00043 14.1132 7.98903 14.1132 9.00034C14.1132 10.3565 13.5744 11.6571 12.6155 12.616C11.6566 13.5749 10.356 14.1136 8.99986 14.1136Z"
        fill="currentColor"
      />
      <path
        d="M8.99968 8.14844C8.77365 8.14844 8.55689 8.23822 8.39707 8.39805C8.23725 8.55787 8.14746 8.77463 8.14746 9.00065V11.5573C8.14746 11.7833 8.23725 12.0001 8.39707 12.1599C8.55689 12.3197 8.77365 12.4095 8.99968 12.4095C9.2257 12.4095 9.44246 12.3197 9.60228 12.1599C9.76211 12.0001 9.85189 11.7833 9.85189 11.5573V9.00065C9.85189 8.77463 9.76211 8.55787 9.60228 8.39805C9.44246 8.23822 9.2257 8.14844 8.99968 8.14844Z"
        fill="currentColor"
      />
      <path
        d="M8.99968 7.08334C9.47034 7.08334 9.85189 6.70179 9.85189 6.23112C9.85189 5.76046 9.47034 5.37891 8.99968 5.37891C8.52901 5.37891 8.14746 5.76046 8.14746 6.23112C8.14746 6.70179 8.52901 7.08334 8.99968 7.08334Z"
        fill="currentColor"
      />
    </svg>
  );
}
